import { Backend, IApi } from './backend'
import { AxiosResponse } from 'axios'
import { IRequest } from './index'
import IPaymentDetail from './../models/paymentDetail'

export default class PaymentDetail extends Backend {
  static getTableData(
    request: IRequest
  ): Promise<AxiosResponse<{ rows: IPaymentDetail[]; count: number }>> {
    const api: IApi = {
      url: '/api/paymentDetail/tableData',
      method: 'get',
      data: { request }
    }
    return this.request<{ rows: IPaymentDetail[]; count: number }>(api)
  }
  static createOrUpdate(data: any): Promise<AxiosResponse<IPaymentDetail>> {
    const api: IApi = {
      url: '/api/paymentDetail/createOrUpdate',
      method: 'post',
      data
    }
    return this.request<IPaymentDetail>(api)
  }
  static delete(id: number): Promise<AxiosResponse> {
    const api: IApi = {
      url: `/api/paymentDetail/${id}`,
      method: 'delete'
    }
    return this.request(api)
  }
}
